<template>
  <div class="host vm-dynamic-form">
    <form @submit.prevent="$emit('submit')">
      <form-group
        @input="$emit('input', $event)"
        @add="$emit('add', $event)"
        @remove="$emit('remove', $event)"
        :scheme="scheme"
        :options="options"
        :data="data"
        @select="$emit('select', $event)"
      >
        <template #bottom>
          <Button class="vm-cancel-button" @click="$emit('cancel')">
            Отменить
          </Button>
          <Button type="submit" color="primary">
            {{ submitLabel }}
          </Button>
        </template>
      </form-group>
    </form>
  </div>
</template>

<script>
import FormGroup from './FormGroup';
import Button from '../Button';

export default {
  components: { FormGroup, Button },
  props: {
    submitLabel: {
      type: String,
      default: 'Сохранить'
    },
    scheme: Object,
    data: Object,
    options: {
      type: Object,
      default: null
    }
  }
};
</script>

<style scoped>
.vm-cancel-button {
  margin-right: 12px;
}
</style>
